// extracted by mini-css-extract-plugin
export default {"container":"logout-widget__container___fUcrh","title":"logout-widget__title___eklNB","email":"logout-widget__email___qVF1U","button":"logout-widget__button___eYEWJ"};